import React from "react";

const WorkingProcedure = () => {
  return (
    <div className="container">
      <div className="card text-dark bg-light mb-3">
        <div className="card-header">Working Procedure</div>
        <div className="card-body">
          <h5 className="card-title">Screen Recorder App</h5>
          <p className="card-text">
             Here this app is buit for Screen recording and downloading. If visitor visit this app and click on the Record Button , he or she will go to the Record-App. In that Page, visitor can start, stop, Pause and Resume recording screen.
             If the record is done ,, visitor can dowload and easily play for this .
          </p>
        </div>
      </div>
    </div>
  );
};

export default WorkingProcedure;
